export const GEOCODER_ERROR = 'There was an error getting location';
export const GENERIC_MAPS_ERROR = 'Something went wrong loading the map. Please try again later';
